module.exports = __webpack_public_path__ + "img/211f3f8b47a24a1cbce8d871a663b7b0-1024.e456beab.jpg";